<template>
  <!--搜索页面-->
  <tk-container
    :status="status"
    class="b-g-f"
  >
    <tkui-header slot="header">
      <div slot="left-menu" @click="back">
        <tkui-button class="icon">
          <tk-icon size="16" color="#666">fanhui</tk-icon>
        </tkui-button>
      </div>
      <!--搜索输入框-->
      <tk-flex class="full">
        <tkui-search-input class="tkui-search-input" v-model="searchWord" :place-holder="`大家都在搜：${allWord}`"></tkui-search-input>
      </tk-flex>
      <!--搜索按钮-->
      <div class="post-btn" slot="right">
        <tkui-button
          class="primary raised rounded small"
          @click="nextPage(searchWord ? searchWord : searchWord ? searchWord : allWord)"
          style="height: 30px;"
        >
          搜索
        </tkui-button>
      </div>
    </tkui-header>
    <!--历史记录显示-->
    <card
      :height="50"
      :width="100"
      class="p-12"
      v-if="searchWords.length"
    >
      <tk-flex middle between>
        <div class="font-bold font-14">历史记录</div>
        <div @click="emptySearchWords">
          <tk-icon size="19">lajixiang</tk-icon>
        </div>
      </tk-flex>
      <tk-flex wrap>
        <tk-flex
          center
          class="tk-grid-3 font-14 m-t-12 search-btn"
          @click.native="nextPage(s)"
          v-for="(s, index) in searchWords"
          :key="index"
        >
          <div>{{s}}</div>
        </tk-flex>
      </tk-flex>
    </card>
    <!--无历史记录渲染-->
    <empty-tips v-else class="m-t-20" :height="100" :width="100" :empty-msg="'暂无历史数据'"></empty-tips>
    <!--热门搜索显示-->
    <card
      :height="50"
      :width="100"
      v-if="popularSearch.length"
    >
      <div class="font-bold font-14">热门搜索</div>
      <tk-flex wrap gutter="5">
        <tk-flex
          center
          class="tk-grid-3 font-14 p-t-12 search-btn"
          @click.native="nextPage(s.word)"
          v-for="(s, index) in popularSearch"
          :key="index"
        >
          <div>{{s.word ? s.word : ''}}</div>
        </tk-flex>
      </tk-flex>
    </card>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      searchWord: '', // 搜索model
      popularSearch: [] // 热门搜索数据
    }
  },
  computed: {
    // 搜索历史数据
    searchWords () {
      return this.$store.state.searchWords
    },
    // 大家都在搜
    allWord () {
      if (!this.popularSearch.length) { return '' }
      return this.popularSearch[0].word
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/8
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        let popularSearch = await this.$tkParse.getList('/classes/popularSearch', {
          params: {
            limit: 6,
            order: '-createdAt'
          }
        }) // 获取热门搜索数据
        if (popularSearch.length) { this.popularSearch = popularSearch } else { this.popularSearch = [] }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 清空搜索记录
    * @date: 2020/4/8
    */
    emptySearchWords () {
      this.$store.commit('setSearchWords', [])
      this.$tkHelper.sleep(500)
      this.$tkGlobal.toast.add('历史记录已清空')
      this.$forceUpdate()
    },
    /**
    * 跳转到下个页面
    * @date: 2020/4/10
    */
    nextPage (word) {
      if (!word) { return this.$tkGlobal.toast.add('未找到您要搜索的关键词') }
      this.$setFlash('searchWord', word)
      this.$push({ path: '/common/commodityList', query: { type: 'search' } })
    },
    /**
    * 返回
    * @date: 2020/4/10
    */
    back () {
      if (this.$getFlash('toggleSearch') && this.$getFlash('toggleSearch') === 'class') {
        this.$cleanHistory()
        this.$router.replace('/')
        return
      }
      this.$back('/')
    }
  }
}
</script>

<style scoped lang="scss">
/*输入框样式*/
  .tkui-search-input {
    width: 95%;
  }
  /*搜索词样式*/
  .search-btn div {
    width: 80px;
    height: 30px;
    background-color: rgba(248, 248, 248, 1);
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
